import React, { FC } from 'react';
import List from 'components/fields/components/List';

const Screen: FC = () => (
  <List
    entityName="client-fields"
    entityEndpoint="client-fields"
  />
);

export default Screen;
